export default "__VITE_ASSET__DibQBQsN__";